import { render, staticRenderFns } from "./MailCreate.vue?vue&type=template&id=58c33ca7"
import script from "./MailCreate.vue?vue&type=script&lang=js"
export * from "./MailCreate.vue?vue&type=script&lang=js"
import style0 from "./MailCreate.vue?vue&type=style&index=0&id=58c33ca7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports